import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'; // further imports omitted
import { Row, Col, Card } from 'react-bootstrap';
import { AddCircle, CloudDownload, FolderOpen } from '@material-ui/icons';
import { importLedmodule } from '../../../actions';

class ChooseLedmodule extends React.Component {

    constructor() {

        super();

        this.onChangeFile = this.onChangeFile.bind(this);
        this.createLedmodule = this.createLedmodule.bind(this);
    }

    createLedmodule() {
        // this.props.setTemporaryLedmodule(true);
        this.props.history.push('/ledmodules/new/info');
    }

    onChangeFile(e) {

        const files = Array.from(e.target.files);

        if (files.length !== 1) {
            return;
        }

        this.props.importLedmodule(files[0])
            .then(() => {
                this.props.history.push('/ledmodules/' + this.props.ledmodule.id + '/info', { state: this.state });
                this.props.history.go('/ledmodules/' + this.props.ledmodule.id + '/info');
            })
            .catch(() => {
                document.getElementById("inputFile").value = null;
            });
    }

    openFileDialog() {
        document.getElementById("inputFile").click();
    }

    render() {
        return (
            <Card className="card-choose-ledmodule">
                <div className='card-header-choose-ledmodule'>
                    <h6 style={{ marginBottom: '0' }}>LED Module Store</h6>
                </div>
                <Card.Body style={{ padding: '0' }}>
                    <Row className='card-row-up-choose-ledmodule'>
                        <Col>
                            <div className="a-welcome" onClick={this.createLedmodule}>
                                <AddCircle color='action' style={{ fontSize: '4rem' }} />
                                <br />
                                Create New Ledmodule
                            </div>
                            {/* <Link to={`/ledmoduleNew`} className="a-welcome">
                                <FontAwesomeIcon color='action' size='5x' icon={faPlusCircle} />
                                <br />
                                Create New Ledmodule
                            </Link> */}
                        </Col>
                    </Row>
                    <Row className='card-row-down-choose-ledmodule'>
                        <Col sm="6" style={{ borderRight: "1px solid rgba(0,0,0,.125)" }}>
                            <div className="a-welcome" onClick={this.openFileDialog}>
                                <FolderOpen color='action' style={{ fontSize: '4rem' }} />
                                <br />
                                Import file <br /> from computer
                                <input type='file' accept='.xml' id="inputFile" onChange={this.onChangeFile} hidden />
                            </div>
                        </Col>
                        <Col sm="6">
                            <Link to={`/ledmodules`} className="a-welcome">
                                <CloudDownload color='action' style={{ fontSize: '4rem' }} />
                                <br />
                                Open ledmodule <br /> from cloud
                            </Link>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        ledmodule: state.ledmodule.info,
        original: state.ledmodule.original
    };
};

const mapDispatchToProps = {
    importLedmodule,
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ChooseLedmodule));